import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BANNER_NAME = 'active-quote-banner';
const ActiveQuoteBanner = ({
  handleClickQuote,
  handleClickClose,
  trackBannerInteraction
}) => {
  useEffect(() => {
    trackBannerInteraction === null || trackBannerInteraction === void 0 || trackBannerInteraction({
      action: 'view',
      name: BANNER_NAME
    });
  }, [trackBannerInteraction]);
  const onClose = () => {
    trackBannerInteraction === null || trackBannerInteraction === void 0 || trackBannerInteraction({
      action: 'dismiss',
      name: BANNER_NAME
    });
    handleClickClose === null || handleClickClose === void 0 || handleClickClose();
  };
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium-id": BANNER_NAME,
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "activeQuote.title"
    }),
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "activeQuote.text"
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "extra-small",
        onClick: handleClickQuote,
        "data-selenium-id": "active-quote-purchase-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "activeQuote.link"
        })
      })]
    })
  });
};
export default ActiveQuoteBanner;